import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-navigate-next-btn',
  templateUrl: './navigate-next-btn.component.html',
  styleUrls: ['./navigate-next-btn.component.scss'],
})
export class NavigateNextBtnComponent {
  @Input() buttonClass: string = '';
  @Input() showIcon: boolean = true;
  @Input() handleOnClick: boolean = false;
  @Input() disabled: boolean = false;
  @Input() isConfirm: boolean = false;
  @Input() buttonTextOverride: string;
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  get buttonText(): string {
    return this.isConfirm ? 'EXTRAS_PAGE.NEXT_CONFIRM_BTN' : 'EXTRAS_PAGE.NEXT_BTN';
  }

  handleClick(): void {
    if (this.handleOnClick) {
      this.onClick.emit();
    }
  }
}
